import { BillingAccount } from 'app/page/orders/model/billing-account';

export class BillingAccountUtils {
    public static getBillingAccount(billingAccounts: BillingAccount[], billingAccountId: string): BillingAccount {
        return (
            billingAccounts.find((billingAccount) => billingAccount.accountId === billingAccountId) ||
            (() => {
                throw new Error(`Cannot find billing account ${billingAccountId}`);
            })()
        );
    }
}
